let sessionId;
export function refreshSessionTimer (time, callback) {
    clearTimeout(sessionId);
    sessionId = setTimeout(callback, time);
}

let pageId;
export function refreshPageTimer (time, callback) {
    clearTimeout(pageId);
    pageId = setTimeout(callback, time);
}
